import { createFileRoute } from "@tanstack/react-router";
import { sanityClient } from "@/lib/sanity";
import { pickLocalized, DEFAULT_LOCALE } from "@/lib/i18n";
import { pageMeta } from "@/lib/seo";

export const Route = createFileRoute("/pricing")({
  loader: () => sanityClient.fetch<any>(`*[_type == "sitePage" && pageKey == "pricing"][0]{ seo }`),
  head: ({ loaderData }) =>
    pageMeta({
      title: pickLocalized(loaderData?.seo?.metaTitle, DEFAULT_LOCALE) || "Pricing — Matchamind",
      description: pickLocalized(loaderData?.seo?.metaDescription, DEFAULT_LOCALE) || undefined,
      path: "/pricing",
    }),
  component: PricingPage,
});

function PricingPage() {
  return (
    <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
      <header className="mx-auto max-w-2xl text-center">
        <h1 className="font-display text-4xl font-semibold tracking-tight md:text-5xl">
          Pricing
        </h1>
        <p className="mt-4 text-muted-foreground">
          Plans and pricing details coming soon.
        </p>
      </header>
    </div>
  );
}
